import { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { clearSubmitErrors } from 'redux-form'

import { trackEvent } from '@offerzen/pinata-shame'

import { searchResults, loading, searching, editing, skillsList, selectedSkillsCount } from '../../selectors/skills'
import { updateProgress as reduxUpdateProgress } from '../../redux/modules/utility'
import {
  fetchSkills as reduxFetchSkills,
  searchSkills as reduxSearchSkills,
  updateSkills as reduxUpdateSkills,
} from '../../redux/modules/skills'
import { nextOnboardingUrl } from '../../helpers/onboardingSteps'

class Skills extends Component {
  componentDidMount() {
    this.props.updateProgress(16)
    trackEvent('onboarding-skills-accessed')

    this.props.fetchSkills()
  }

  render() {
    const { children, ...rest } = this.props
    return children({ ...rest })
  }
}

const mapStateToProps = state => ({
  candidateId: state.candidate.id,
  userId: state.candidate.user_id,
  candidateName: state.candidate.first_name,
  editing: editing(state),
  loading: loading(state),
  searching: searching(state),
  searchResults: searchResults(state),
  skillsList: skillsList(state),
  selectedSkillsCount: selectedSkillsCount(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  goToNextStep: () => {
    const url = nextOnboardingUrl(ownProps.location.pathname)
    ownProps.history.push(url)
  },
  updateProgress: progress => dispatch(reduxUpdateProgress(progress)),
  fetchSkills: candidateId => dispatch(reduxFetchSkills(candidateId)),
  searchSkills: text => dispatch(reduxSearchSkills(text)),
  updateSkills: (candidateId, skills, resolve, reject) => dispatch(reduxUpdateSkills(candidateId, skills, resolve, reject)),
  clearErrors: () => dispatch(clearSubmitErrors('skills')),
  trackRemovedSkill: skill =>
    trackEvent('Candidate: profile action', {
      action: 'removed skill',
      source: 'onboarding',
      skill,
    }),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  fetchSkills: () => dispatchProps.fetchSkills(stateProps.candidateId),
  updateSkills: (skills, resolve, reject) => dispatchProps.updateSkills(stateProps.candidateId, skills, resolve, reject),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(Skills))
